import {H1, TextRegular, TextMedium, Button, Icon} from '@hm/fundamental'
import {mdiEmailOutline} from '@mdi/js'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {PO_CONTACT_EMAIL} from '../api/constants'
import {ReactComponent as NoPlants} from '../assets/noPlants.svg'
import {openEmail} from '../utils/openEmail'

export const NoHierarchyPage: React.FC = () => {
  const {t} = useTranslation()

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-6 text-center px-6 py-8"
      data-cy="no_hierarchy_page"
    >
      <NoPlants aria-hidden="true" className="w-72 h-auto" />
      <div className="w-auto">
        <H1 className="text-foreground_inverted" data-cy="no_hierarchy_title">
          {t('suite.noHierarchy.title')}
        </H1>
        <div className="mt-6">
          <TextRegular
            className="text-foreground_faded max-w-[75ch] mx-auto"
            data-cy="no_hierarchy_description"
          >
            {t('suite.noHierarchy.description')}
          </TextRegular>
        </div>
      </div>
      <Button
        variant="secondary"
        onClick={() => {
          openEmail(
            PO_CONTACT_EMAIL,
            t('suite.noHierarchy.contactSubject', 'No plants assigned to account')
          )
        }}
        data-cy="no_hierarchy_contact_button"
      >
        <div className="flex items-center gap-2">
          <TextMedium>{t('suite.noHierarchy.contactButton')}</TextMedium>
          <Icon path={mdiEmailOutline} size="regular" />
        </div>
      </Button>
    </div>
  )
}
